import { configureStore as configureStoreReduxToolkit } from '@reduxjs/toolkit';
import createReducer from './reducers';
import * as analytics from './analytics/analytics';
import config from './config';

/**
 * Create a new store with the given initial state (the template's store).
 * Redux Toolkit adds Redux Thunk, with the SDK as the thunks' extra argument, and the
 * analytics middleware runs first. Redux DevTools are enabled in client-side dev mode.
 */
export default function configureStore({
  initialState = {},
  sdk = null,
  analyticsHandlers = [],
  extraMiddlewares = [],
} = {}) {
  return configureStoreReduxToolkit({
    reducer: createReducer(),
    preloadedState: initialState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: { extraArgument: sdk },
        // The store holds class-based values: UUIDs, Money, LatLng, Dates and Decimals.
        serializableCheck: false,
      })
        .prepend(analytics.createMiddleware(analyticsHandlers))
        .concat(extraMiddlewares),
    devTools: config.dev && typeof window === 'object',
  });
}
